import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import { ChangeCursor } from "../../hlthtek-demo/components/MiscFunctions";
import axios from "axios";
import Navbar from "./Navbar";
import { toast } from "react-toastify";
//is kept hidden for now
function FacilityCustomer({ updateList }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
  } = useForm();
  const [userType, setUserType] = useState([
    "Choose User Type",
    "Admin",
    "User",
  ]);
  const [facilityList, setFacilityList] = useState([
    "-select-",
    "HMIS",
    "EHR",
    "LIMS",
    "MedTech",
  ]);

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const [states, setStates] = useState("");
  const [cities, setCities] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  const roleTypeLoggedin = sessionStorage.getItem("roleType");
  const [colorHex, setColorHex] = useState("");

  // useEffect(() => {
  //   if (
  //     (sessionStorage.getItem("accessToken") == undefined &&
  //       sessionStorage.getItem("accessToken") == null) ||
  //     (sessionStorage.getItem("roleType") !== "admin" &&
  //       sessionStorage.getItem("roleType") !== "partner admin")
  //   ) {
  //     history.push("/login");
  //   }
  // }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  useEffect(() => {
    getAllPartners();
  }, []);

  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_states/`, {
          headers: headers,
        })
        .then((res) => {
          setStates(res.data.state_list);
          console.log(res.data.state_list);
        });
    }
  }, [authToken]);

  const getStates = (stateName) => {
    console.log("stateName", stateName);
    var post_data = {
      state_name: stateName,
    };

    if (authToken !== "") {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_districts/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log(res.data);
          setCities(res.data.district_list);
        });
    }
  };
  function getAllPartners() {
    if (Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_partners_list/`, {
          headers: headers,
        })
        .then((response) => {
          console.log("response", response.data.partner_list);
          setPartnerList(response.data.partner_list);
        })
        .catch((error) => {
          console.log("FETCH FAILED");
          console.log(error);
        });
    }
  }

  useEffect(() => {
    if (
      (sessionStorage.getItem("roleType") === "admin" ||
        sessionStorage.getItem("roleType") === "partner admin") &&
      Token()
    ) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_registered_facilities/`, {
          headers: headers,
        })
        .then((res) => {
          // setFacilityList(res.data.services)
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, [authToken]);
  // const onSubmit = (data, e) => {
  //   // console.log(getValues("user_type"))
  //   if (getValues("user_type") === userType[0]) {
  //     setError(
  //       "user_type",
  //       { type: "validate", message: "User Type is required" },
  //       { shouldFocus: true }
  //     );
  //     return;
  //   }
  //   e.preventDefault();
  //   console.log(data);
  //   if (Token()) {
  //     //ChangeCursor();
  //     var post_data = {};
  //     post_data.client_id = data.client_id;
  //     post_data.company_name = data.company_name;
  //     post_data.phone = data.phone;
  //     post_data.email = data.email;
  //     post_data.building = data.building;
  //     post_data.city = data.city;
  //     post_data.pincode = data.pincode;
  //     post_data.state = data.state;
  //     post_data.registration_number = data.registration_number;
  //     // post_data.primary_person = data.primary_person
  //     // post_data.primary_email = data.primary_email
  //     // post_data.primary_phone = data.primary_phone
  //     // post_data.secondary_person = data.secondary_person
  //     // post_data.secondary_email = data.secondary_email
  //     // post_data.secondary_phone = data.secondary_phone
  //     post_data.activation_date = data.activation_date;
  //     // post_data.client_type = "Customer"
  //     if (roleTypeLoggedin === "admin") {
  //       post_data.partner_id = data.partner;
  //     }
  //     post_data.created_date = new Date();
  //     post_data.active = data.active;
  //     console.log(data);
  //     console.log(post_data);

  //     axios
  //       .post(
  //         `${REACT_APP_BACKEND_ROUTE_URL}add_new_facility_customer/`,
  //         JSON.stringify(post_data),
  //         {
  //           headers: headers,
  //         }
  //       )
  //       .then((res) => {
  //         console.log(res.data);
  //         if (res.data.status === "Success") {
  //           toast.success("Customer Added !!");
  //           console.log(res);
  //           updateList();
  //           //ChangeCursor();
  //         } else if (res.data.status === "Failed") {
  //           // Check if the message contains a duplicate entry error
  //           if (
  //             res.data.message &&
  //             res.data.message.includes("Duplicate entry")
  //           ) {
  //             toast.error(
  //               "Duplicate entry error: A customer with the same registration number already exists."
  //             );
  //           } else {
  //             toast.error("Customer Not Added !! Try again later");
  //           }
  //           console.log(res);
  //           //ChangeCursor();
  //         } else {
  //           toast.error("Customer Not Added !! Try again later");
  //           console.log(res);
  //           //ChangeCursor();
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         toast.error(err);
  //         //ChangeCursor();
  //       });
  //   }
  // };
  const onSubmit = (data, e) => {
    e.preventDefault();
    console.log("data", data);
    console.log("colorHex", colorHex);
    // First: Create a new customer
    const createCustomer = () => {
      var post_data = {};
      post_data.client_id = data.client_id;
      post_data.company_name = data.company_name;
      post_data.phone = data.phone;
      post_data.email = data.email;
      post_data.building = data.building;
      post_data.city = data.city;
      post_data.pincode = data.pincode;
      post_data.state = data.state;
      post_data.registration_number = data.registration_number;
      post_data.activation_date = data.activation_date;
      if (roleTypeLoggedin === "admin") {
        post_data.partner_id = data.partner;
      }
      post_data.created_date = new Date();
      post_data.active = data.active;

      // Call the customer creation API
      return axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}add_new_facility_customer/`,
        JSON.stringify(post_data),
        {
          headers: headers,
        }
      );
    };

    // Second: Call branding upload API after customer creation success
    const uploadBrandingData = () => {
      const formData = new FormData();

      // formData.append("functionality", "branding");
      // formData.append("segment", "images");

      // formData.append("config_type", "configuration");

      formData.append("bucket_type", "license");
      formData.append("bucket_category", "conf");
      formData.append("facility", false);
      formData.append("client_name", data.company_name);

      // Handle Email Banner Image with fixed name
      if (data.emailBanner && data.emailBanner[0]) {
        const emailBannerFile = new File(
          [data.emailBanner[0]],
          "email_banner.png",
          { type: data.emailBanner[0].type }
        );
        formData.append("file_object", emailBannerFile);
        console.log("Email Banner File to be sent:", emailBannerFile);
      }

      // Handle Collateral Image with fixed name
      if (data.collateralImage && data.collateralImage[0]) {
        const collateralImageFile = new File(
          [data.collateralImage[0]],
          "collateral_image.png",
          { type: data.collateralImage[0].type }
        );
        formData.append("file_object", collateralImageFile);
        console.log("Collateral Image File to be sent:", collateralImageFile);
      }

      // Handle branding statements, convert to JSON and append as file
      // const brandingStatements = {
      //   emailBrandStatement: data.emailBrandStatement,
      //   collateralBrandStatement: data.collateralBrandStatement,
      // };

      const brandingStatements = {
        emailBrandStatement: data.emailBrandStatement,
        collateralBrandStatement: data.collateralBrandStatement,
        themeColour: colorHex,
      };

      const brandingStatementsBlob = new Blob(
        [JSON.stringify(brandingStatements)],
        {
          type: "application/json",
        }
      );

      const brandingStatementsFile = new File(
        [brandingStatementsBlob],
        "branding_statements.json",
        { type: "application/json" }
      );

      formData.append("file_object", brandingStatementsFile);

      // Call the branding API
      return axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}save_facility_branding/`,
        formData,
        {
          headers: {
            ...headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );
    };

    // Main Logic: First create the customer, then upload branding data
    if (Token()) {
      createCustomer()
        .then((res) => {
          if (res.data.status === "Success") {
            toast.success("Customer Added Successfully!");

            // Now call the branding upload API
            uploadBrandingData()
              .then((brandingRes) => {
                if (brandingRes.data.status === "success") {
                  toast.success("Branding Data Saved Successfully!");
                  updateList(); // Update the list after successful save
                  // } else {
                  //   toast.error(
                  //     brandingRes.data.message || "Error Saving Branding"
                  //   );
                  // }
                } else {
                  const message =
                    brandingRes.data.message || "An unknown error occurred.";
                  if (message.includes("corrupted")) {
                    toast.error(
                      "The Facility documents uploaded are corrupted. Please try with a different document."
                    );
                  } else if (message.includes("Virus")) {
                    toast.error(
                      "The Facility documents uploaded has virus. Please try with a different document."
                    );
                  } else {
                    toast.error(message);
                  }
                }
              })
              .catch((brandingErr) => {
                console.log(brandingErr);
                toast.error("Error Saving Branding");
              });
          } else if (res.data.status === "Failed") {
            if (
              res.data.message &&
              res.data.message.includes("Duplicate entry")
            ) {
              toast.error(
                "Duplicate entry error: A customer with the same registration number already exists."
              );
            } else {
              toast.error("Customer Not Added! Try again later.");
            }
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error("Error Adding Customer");
        });
    }
  };

  const handleColorChange = (e) => {
    const value = e.target.value;

    setColorHex(value);
  };

  return (
    <div>
      {/* <Navbar /> */}
      <h1 style={{ textAlign: "center" }}>Add New Customer</h1>
      <div className="col-sm-12 col-md-12 col-lg-7" style={{ margin: "auto" }}>
        <div className="contact-panel mb-50">
          <form
            className="contact-panel__form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  {/* <i className="icon-news form-group-icon"></i> */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Customer ID"
                    name="client_id"
                    hidden
                    disabled
                    value={""}
                    {...register("client_id")}
                  />
                </div>
              </div>
              <div className="col-12">
                <label className="required-label">Partner Type </label>
                <div className="form-group">
                  <i className="icon-user form-group-icon"></i>
                  <select
                    className="form-control"
                    name="partner_company_name"
                    {...register("partner_company_name", {
                      required: "partner type is required.",
                    })}
                  >
                    {facilityList !== undefined && facilityList.length > 0
                      ? facilityList.map((item, index) => (
                          <option value={item}>{item}</option>
                        ))
                      : []}
                  </select>
                  {/* {errors.facility && (
                                    <p className="errorMsg">{errors.facility.message}</p>
                                )} */}
                </div>
              </div>
              {roleTypeLoggedin === "admin" && (
                <div className="col-sm-6 col-md-6 col-lg-6">
                  {/* <label htmlFor="partner" className="required-label"> */}
                  <label htmlFor="partner">Partners</label>
                  <select
                    className="form-control"
                    name="partner"
                    {...register(
                      "partner"
                      //   {
                      //   required: "Partner is required.",
                      // }
                    )}
                  >
                    <option value="">Select Partner</option>
                    {partnerList &&
                      partnerList.map((partner, index) => (
                        <option key={index} value={partner.partner_id}>
                          {partner.company_name}
                        </option>
                      ))}
                  </select>
                  {errors.partner && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.partner.message}
                    </p>
                  )}
                </div>
              )}

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="company_name" className="required-label">
                  Customer Company Name{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Customer Company Name"
                    name="company_name"
                    {...register("company_name", {
                      required: "Customer Company Name is required.",
                      pattern: {
                        value: /[A-Za-z]/,
                        message:
                          "Company Name must contain at least alphabetic character.",
                      },
                    })}
                  />
                  {errors.company_name && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.company_name.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="client_phone" className="required-label">
                  Customer Phone no.{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Customer Phone no."
                    name="client_phone"
                    {...register("phone", {
                      required: "Customer Phone no. is required.",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Phone number must be a 10-digit number.",
                      },
                    })}
                  />
                  {errors.phone && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.phone.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <label htmlFor="client_email" className="required-label">
                  Customer Contact Email{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Customer Contact Email"
                    name="client_email"
                    {...register("email", {
                      required: "Customer Email is required.",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.email.message}
                    </p>
                  )}
                </div>
              </div>

              <h6>Customer Address*</h6>
              <div className="col-12">
                <label htmlFor="client_building" className="required-label">
                  Building/Street No./Flat No.
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Building/Street No./Flat No."
                    name="partner_building"
                    {...register("building", {
                      required:
                        "Partner Building/Street No./Flat No. is required.",
                    })}
                  />
                  {errors.building && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.building.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="state" className="required-label">
                  States{" "}
                </label>

                <select
                  className="form-control"
                  name="state"
                  {...register("state", {
                    required: "State is required.",
                  })}
                  onChange={(e) => {
                    // Call getStates here when state selection changes
                    getStates(e.target.value);
                  }}
                >
                  <option value="">Select State</option>
                  {states &&
                    states.map((state, index) => (
                      <option
                        key={index}
                        value={state.state_name.toLowerCase()}
                      >
                        {state.state_name}
                      </option>
                    ))}
                </select>
                {errors.state && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.state.message}
                  </p>
                )}
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="city" className="required-label">
                  City{" "}
                </label>
                <div className="form-group">
                  {/* <label htmlFor="city">City</label> */}
                  <select
                    className="form-control"
                    name="city" // Change "district" to "city" here
                    {...register("city", {
                      required: "City is required.",
                    })}
                  >
                    <option value="">Select City</option>
                    {cities.map((city, index) => (
                      <option
                        key={index}
                        value={city.district_name.toLowerCase()}
                      >
                        {city.district_name}
                      </option>
                    ))}
                  </select>
                  {errors.city && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.city.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="partner_pincode" className="required-label">
                  Pincode{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Pincode"
                    name="partner_pincode"
                    {...register("pincode", {
                      required: "Partner Pincode is required.",
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Pincode must contain only numbers.",
                      },
                    })}
                  />
                  {errors.pincode && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.pincode.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-12">
                <label htmlFor="registration_number" className="required-label">
                  Company Registration No.{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Company Registration No."
                    name="registration_number"
                    {...register("registration_number", {
                      required: "Enter Company Registration No. is required.",
                    })}
                  />
                  {errors.registration_number && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.registration_number.message}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="col-12">
                <h6>Upload Facility Email Banner Image</h6>
                <div className="form-group">
                  <label htmlFor="emailBanner" className="required-label">
                    Upload Email Banner Image{" "}
                  </label>
                  <input
                    type="file"
                    name="emailBanner"
                    accept="image/*"
                    {...register("emailBanner", {
                      required: "Facility Email Banner Image is required.",
                    })}
                  />
                  {errors.emailBanner && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.emailBanner.message}
                    </p>
                  )}
                </div>

                <div className="form-group">
                  <label
                    htmlFor="emailBrandStatement"
                    className="required-label"
                  >
                    Brand Statement (max 250 chars){" "}
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="Enter a brand statement for email (max 250 characters)"
                    name="emailBrandStatement"
                    maxLength={250}
                    {...register("emailBrandStatement", {
                      required: "Brand statement is required.",
                      maxLength: {
                        value: 250,
                        message:
                          "Brand statement should be within 250 characters.",
                      },
                    })}
                  />
                  {errors.emailBrandStatement && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.emailBrandStatement.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-12">
                <h6>Upload Facility Collateral Image</h6>
                <div className="form-group">
                  <label htmlFor="collateralImage" className="required-label">
                    Upload Collateral Image{" "}
                  </label>
                  <input
                    type="file"
                    name="collateralImage"
                    accept="image/*"
                    {...register("collateralImage", {
                      required: "Facility Collateral Image is required.",
                    })}
                  />
                  {errors.collateralImage && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.collateralImage.message}
                    </p>
                  )}
                </div>

                <div className="form-group">
                  <label
                    htmlFor="collateralBrandStatement"
                    className="required-label"
                  >
                    Brand Statement (max 250 chars){" "}
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="Enter a brand statement for collateral (max 250 characters)"
                    name="collateralBrandStatement"
                    maxLength={250}
                    {...register("collateralBrandStatement", {
                      required: "Brand statement is required.",
                      maxLength: {
                        value: 250,
                        message:
                          "Brand statement should be within 250 characters.",
                      },
                    })}
                  />
                  {errors.collateralBrandStatement && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.collateralBrandStatement.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <label htmlFor="colorPicker" className="required-label">
                  Selected Colour
                </label>
                <div className="form-group">
        
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Select a colour to see"
                    disabled
                    value={colorHex}
                    onChange={handleColorChange}
                    {...register("brand_color", {
                      pattern: {
                        value: /^#[0-9A-Fa-f]{6}$/,
                        message: "Invalid hexadecimal color format.",
                      },
                    })}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="colorPicker" className="required-label">
                  Choose Brand Color
                </label>
                <input
                  type="color"
                  className="form-control mt-2"
                  value={colorHex}
                  onChange={handleColorChange}
                />
              </div> */}

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label className="required-label">Activation Date </label>
                <div className="form-group form-group-date">
                  <i className="icon-calendar form-group-icon"></i>
                  <input
                    type="date"
                    className="form-control"
                    id="contact-date"
                    name="activation_date"
                    {...register("activation_date")}
                    required
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      placeholder="Active"
                      name="active"
                      {...register("active")}
                    />
                    <label class="form-check-label" for="flexRadioDefault2">
                      Active
                    </label>
                  </div>
                  {errors.active && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.active.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="contact-panel mb-50" style={{ padding: "0px" }}>
                  <div className="card-header">
                    <h5>Branding Information</h5>
                  </div>
                  <div className="card-body">
                    {/* Upload Facility Email Banner Image */}
                    <div className="col-12">
                      <p>
                        <strong style={{ color: "red" }}>NOTE:</strong> The
                        email banner image will be used in all customer-facing
                        email communications. Please ensure it is reflective of
                        your brand. Please use an image of size at least 20KB
                        and at most 10MB. Recommended resolution:{" "}
                        <strong>3000x1000</strong> pixels
                      </p>
                      <h6>Upload Facility Email Banner Image</h6>

                      <div className="form-group">
                        <label htmlFor="emailBanner" className="required-label">
                          Upload Email Banner Image{" "}
                        </label>
                        <input
                          type="file"
                          name="emailBanner"
                          accept="image/*"
                          {...register("emailBanner", {
                            required:
                              "Facility Email Banner Image is required.",
                            validate: {
                              minSize: (fileList) => {
                                if (!fileList || fileList.length === 0)
                                  return "File is required.";
                                const file = fileList[0];
                                return (
                                  file.size >= 20 * 1024 ||
                                  "File size must be at least 20KB."
                                );
                              },
                              maxSize: (fileList) => {
                                if (!fileList || fileList.length === 0)
                                  return true; // Skip further validation if no file exists
                                const file = fileList[0];
                                return (
                                  file.size <= 10 * 1024 * 1024 ||
                                  "File size must not exceed 10MB."
                                );
                              },
                            },
                          })}
                        />
                        {errors.emailBanner && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.emailBanner.message}
                          </p>
                        )}
                      </div>

                      <div className="form-group">
                        <label
                          htmlFor="emailBrandStatement"
                          className="required-label"
                        >
                          Brand Statement (max 250 chars){" "}
                        </label>
                        <textarea
                          className="form-control"
                          placeholder="Enter a brand statement for email (max 250 characters)"
                          name="emailBrandStatement"
                          maxLength={250}
                          {...register("emailBrandStatement", {
                            required: "Brand statement is required.",
                            maxLength: {
                              value: 250,
                              message:
                                "Brand statement should be within 250 characters.",
                            },
                          })}
                        />
                        {errors.emailBrandStatement && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.emailBrandStatement.message}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Collateral Image Upload */}
                    <div className="col-12">
                      <p>
                        <strong style={{ color: "red" }}>NOTE:</strong> This
                        image will be used in your printed and digital marketing
                        collateral. Ensure it is of high quality and reflects
                        your brand. Please use an image of size at least 20KB
                        and at most 10MB.Recommended resolution:{" "}
                        <strong>400 x 100</strong> pixels
                      </p>
                      <h6>Upload Facility Collateral Image</h6>

                      <div className="form-group">
                        <label
                          htmlFor="collateralImage"
                          className="required-label"
                        >
                          Upload Collateral Image{" "}
                        </label>
                        <input
                          type="file"
                          name="collateralImage"
                          accept="image/*"
                          {...register("collateralImage", {
                            required: "Facility Collateral Image is required.",
                            validate: {
                              minSize: (fileList) => {
                                if (!fileList || fileList.length === 0)
                                  return "File is required.";
                                const file = fileList[0];
                                return (
                                  file.size >= 20 * 1024 ||
                                  "File size must be at least 20KB."
                                );
                              },
                              maxSize: (fileList) => {
                                if (!fileList || fileList.length === 0)
                                  return true; // Skip validation if no file exists
                                const file = fileList[0];
                                return (
                                  file.size <= 10 * 1024 * 1024 ||
                                  "File size must not exceed 10MB."
                                );
                              },
                            },
                          })}
                        />
                        {errors.collateralImage && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.collateralImage.message}
                          </p>
                        )}
                      </div>

                      <div className="form-group">
                        <label
                          htmlFor="collateralBrandStatement"
                          className="required-label"
                        >
                          Brand Statement (max 250 chars){" "}
                        </label>
                        <textarea
                          className="form-control"
                          placeholder="Enter a brand statement for collateral (max 250 characters)"
                          name="collateralBrandStatement"
                          maxLength={250}
                          {...register("collateralBrandStatement", {
                            required: "Brand statement is required.",
                            maxLength: {
                              value: 250,
                              message:
                                "Brand statement should be within 250 characters.",
                            },
                          })}
                        />
                        {errors.collateralBrandStatement && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.collateralBrandStatement.message}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Brand Color Picker */}
                    <div className="col-12">
                      <p>
                        <strong style={{ color: "red" }}>NOTE:</strong> This
                        color will be used to theme your customer-facing
                        communications. Make sure it matches your brand
                        guidelines.
                      </p>
                      <label htmlFor="colorPicker" className="required-label">
                        Selected Colour
                      </label>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Select a colour to see"
                          disabled
                          value={colorHex}
                          onChange={handleColorChange}
                          {...register("brand_color", {
                            pattern: {
                              value: /^#[0-9A-Fa-f]{6}$/,
                              message: "Invalid hexadecimal color format.",
                            },
                          })}
                        />
                      </div>
                    </div>

                    <div className="col-sm-4 col-md-4 col-lg-4">
                      <label htmlFor="colorPicker" className="required-label">
                        Choose Brand Colour
                      </label>
                      <input
                        type="color"
                        className="form-control mt-2"
                        value={colorHex}
                        onChange={handleColorChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                >
                  <span>Add Customer</span> <i className="icon-arrow-right"></i>
                </button>
                <div className="contact-result"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FacilityCustomer;
